import axios from "axios";
import { BACKEND_URL } from "../config";

const API_BASE_URL = BACKEND_URL;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // ✅ include cookies in all requests
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Authentication interceptor - add token for endpoints that require authentication
// GET /post/contents/ is public, but POST/PUT/DELETE require authentication
axiosInstance.interceptors.request.use(
  (config) => {
    // Attach token for JWT-based APIs that require authentication
    // Google OAuth uses session cookies (withCredentials), but regular sign-in needs JWT token

    // Check if this endpoint requires authentication
    // Axios methods are lowercase, so check for "get", "post", "put", "delete"
    const method = (config.method || "").toLowerCase();
    const url = config.url || "";

    // Debug: Log all requests to see what's happening
    // console.log(`🔍 Request interceptor: ${method.toUpperCase()} ${url}`);

    // GET requests to /post/contents are public (no auth needed)
    const isPublicGet = method === "get" && url.startsWith("/post/contents");

    const requiresAuth =
      url.startsWith("/auth") ||
      url.startsWith("/user") ||
      url.startsWith("/me") ||
      url.startsWith("/comment") ||
      url.startsWith("/payment") ||
      url.startsWith("/callback") ||
      url.startsWith("/progress") ||
      (url.startsWith("/course") && method !== "get") ||
      (url.startsWith("/post/contents") && !isPublicGet);

    const token = localStorage.getItem("token");
    if (token && token.trim()) {
      const authHeader = `Bearer ${token.trim()}`;
      if (!config.headers) {
        config.headers = {};
      }
      config.headers["Authorization"] = authHeader;
      // console.log(`✅ Added Authorization header for ${method.toUpperCase()} ${url}`);
    } else if (requiresAuth) {
      console.warn(`⚠️ Authentication required for ${method.toUpperCase()} ${url} but no token found`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
